import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Space, Typography } from 'antd';
import { Link } from 'react-router-dom';
const StatisticCard = ({ title, value, icon, color, keys, R, Y, B }) => {
    return (_jsx(Link, { to: `/projects?key=${keys != null ? keys : ''}&y=${Y != 0 ? Y : ''}&b=${B != 0 ? B : ''}&r=${R != null ? R : ''}`, target: "_blank", style: { textDecoration: 'none' }, children: _jsxs("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
            }, children: [_jsx("div", { style: { fontSize: '14px', color: color }, children: _jsxs(Space, { size: 'small', children: [icon, _jsx("span", { children: value })] }) }), _jsx(Typography.Text, { style: {
                        marginTop: '8px', // Add spacing between value and title
                        fontSize: '12px',
                        lineHeight: '16px',
                        maxWidth: '150px',
                        textAlign: 'center',
                        whiteSpace: 'normal', // Allow text wrapping
                        overflow: 'hidden',
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2, // Limit to 2 lines
                    }, children: title })] }) }));
};
export default StatisticCard;
